export default "__VITE_ASSET__Cwuzvr3l__"